import { render, staticRenderFns } from "./EditCommentModal.vue?vue&type=template&id=3b7fce32&scoped=true&"
import script from "./EditCommentModal.vue?vue&type=script&lang=js&"
export * from "./EditCommentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCommentModal.vue?vue&type=style&index=0&id=3b7fce32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7fce32",
  null
  
)

export default component.exports